<template>
  <div :class="$style.sort">
    <button
      type="button"
      :class="$style.button"
      :aria-label="$t('global.sorting')"
      :title="$t('global.sorting')"
      @click="toggleSort"
    >
      <inline-svg
        v-if="isAscending"
        :src="require('@/assets/images/icons/table/sort-arrow-asc.svg')"
        :class="$style.arrow"
      />
      <inline-svg
        v-else
        :src="require('@/assets/images/icons/table/sort-arrow-desc.svg')"
        :class="$style.arrow"
      />
    </button>
  </div>
</template>

<script>
  import { InlineSvgComponent } from 'vue-inline-svg';

  export default {
    components: {
      inlineSvg: InlineSvgComponent,
    },
    props: {
      name: {
        type: String,
        default: 'sort',
      },
    },
    computed: {
      sort() {
        return this.$route.query[this.name] || 'desc';
      },
      isAscending() {
        return this.sort === 'asc';
      },
    },
    methods: {
      toggleSort() {
        this.$router.replace({
          query: {
            ...this.$route.query,
            [this.name]: this.isAscending ? 'desc' : 'asc',
          },
        });
      },
    },
  };
</script>

<style lang="scss" module>
  .sort {
    margin: 0 5px;
  }

  .button {
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .arrow {
    width: 30px;
    height: 20px;
  }
</style>
